export default __webpack_public_path__ + "static/media/icon-nodejs.4c711758.png";